import cn from 'classnames';
import { t } from 'i18n';
import { FC } from 'react';
import { useFixedSurface } from 'students/views/shared/providers/Theme';

interface IManualPlayButtonProps {
  onClick: () => void;
  className?: string;
}

const SURFACE_CLASSES = {
  fixed: 'ln-text-white focus-visible:ln-outline-white',
  themed: 'ln-text-content focus-visible:ln-outline-content'
};

const ManualPlayButton: FC<IManualPlayButtonProps> = ({ onClick, className }) => {
  const isFixedSurface = useFixedSurface();
  const label = t('frontend.member.play.audio.manual_play_button', {
    defaultValue: 'Click to play the sound'
  });

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        SURFACE_CLASSES[isFixedSurface ? 'fixed' : 'themed'],
        'ln-text-[15px] ln-opacity-50 hover:ln-opacity-100 ln-transition-opacity ln-duration-300 ln-delay-300 ln-bg-transparent ln-border-0 focus-visible:ln-outline focus-visible:ln-outline-2 focus-visible:ln-outline-offset-2',
        className
      )}
      aria-label={label}
    >
      {label}
    </button>
  );
};

export default ManualPlayButton;
